import {
  
    LIST_PERMISSION_ONE_USER__FAIL,
    LIST_PERMISSION_ONE_USER_SUCCESS
  } from "../../actions/permissions/type";
  
  const initialState = {
   
    dataPermissionsByuser : []
  };
  const permissionReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      
      case  LIST_PERMISSION_ONE_USER_SUCCESS:
          return {
            ...state,
            dataPermissionsByuser: payload,
          };
    
      case LIST_PERMISSION_ONE_USER__FAIL:
          return {
            ...state,
          };
  
      default:
        return state;
    }
  };
  
  export default permissionReducer;